// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { push } from "connected-react-router";

import { route } from "@routes/helper";
import { formatDateTime } from "@transformers/date";
import { formatAuthoredBy } from "@transformers/names";
import { GSGrid } from "@components";

type OwnProps = $Exact<{
  clientId: string,
  reportData: *,
}>;

type PropsFromDispatch = $Exact<{
  push: typeof push,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export const ReportsAbsenceMonitoringReportTable = ({ clientId, reportData, t }: Props) => (
  <div className="w-100 absence-monitoring-table"></div>
);

const mapDispatchToProps: PropsFromDispatch = {
  push,
};

export default compose(
  localize(),
  connect(undefined, mapDispatchToProps),
)(ReportsAbsenceMonitoringReportTable);
